<template>
  <div class="log-list">
    <el-form :inline="true" class="demo-form-inline" v-loading="loading" size="mini">
      <!--<el-form-item>-->
        <!--<el-input v-model="search" placeholder="输入模块名查询" size="small"></el-input>-->
      <!--</el-form-item>-->
      <el-form-item label="模块">
        <el-select v-model="search.module" placeholder="选择模块">
          <el-option label="全部" value=""></el-option>
          <el-option label="登录管理" value="登录管理"></el-option>
          <el-option label="角色管理" value="角色管理"></el-option>
          <el-option label="账号管理" value="账号管理"></el-option>
          <el-option label="类目管理" value="类目管理"></el-option>
          <el-option label="区域管理" value="区域管理"></el-option>
          <el-option label="订单管理" value="订单管理"></el-option>
          <el-option label="交易管理" value="交易管理"></el-option>
          <el-option label="提现管理" value="提现管理"></el-option>
          <el-option label="线索卡管理" value="线索卡管理"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="操作">
        <el-select v-model="search.optType" placeholder="选择操作">
          <el-option label="全部" value=""></el-option>
          <el-option label="新增" value="新增"></el-option>
          <el-option label="修改" value="修改"></el-option>
          <el-option label="登录" value="登录"></el-option>
          <el-option label="删除" value="删除"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="开始时间">
        <el-date-picker
                v-model="search.startTime"
                type="datetime"
                placeholder="选择日期时间"
                align="center"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item label="结束时间">
        <el-date-picker
                v-model="search.endTime"
                type="datetime"
                placeholder="选择日期时间"
                align="center"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button-group>
          <el-button type="primary" @click="fetch" size="mini">查询</el-button>
        </el-button-group>
      </el-form-item>
    </el-form>

    <el-table :data="list" size="mini">
      <el-table-column prop="dataPk" label="主键"></el-table-column>
      <el-table-column prop="module" label="模块"></el-table-column>
      <el-table-column prop="optType" label="操作"></el-table-column>
      <el-table-column  label="描述" type="expand">
        <template slot-scope="scope">
          {{scope.row.optValue}}
          <!--{{scope.row.operator}} {{scope.row.optType}} 了 {{scope.row.module}}-->
          <!--<template v-if="scope.row.module==='区域管理'">-->
            <!--{{scope.row.optValue.chinese}}-->
          <!--</template>-->
          <!--<template v-if="scope.row.module==='类目管理'">-->
            <!--{{scope.row.optValue.serviceTypeName}}-->
          <!--</template>-->
          <!--<template v-if="scope.row.module==='角色管理'">-->
            <!--{{scope.row.optValue.roleName}}-->
          <!--</template>-->
          <!--<template v-if="scope.row.module==='账号管理'">-->
            <!--{{scope.row.optValue.username}}-->
          <!--</template>-->
          <!--<template v-if="scope.row.module==='认证管理'">-->
            <!--{{scope.row.optValue}}-->
          <!--</template>-->
        </template>
      </el-table-column>
      <el-table-column prop="operator" label="操作人"></el-table-column>
      <el-table-column prop="optTime" label="操作时间"></el-table-column>

    </el-table>
    <br/>
    <div style="float: right">
      <el-pagination
              background
              layout="prev, pager, next"
              @current-change="i=>page=i"
              :page-size="20"
              :page-count="page"
              :total="total">
      </el-pagination>
    </div>

  </div>
</template>

<script>

  import api from '../api'
  const {log} = api



  export default {
    name: "log-list",
    data() {
      return {
        loading: true,
        list: [],
        roles:[],
        total:0,
        page:1,
        search:{
          module:'',
          optType:'',
          startTime:'',
          endTime:''
        }
      };
    },
    watch:{
      page(){
        this.fetch()
      }
    },
    methods: {
      async fetch() {
        this.loading = true;

        let pageNum = this.page
        let {module,optType,startTime,endTime} = this.search
        let obj = {start:(pageNum-1)*20,module,optType,startTime,endTime}
        if(startTime && endTime){
            obj.startTime = Date.parse(obj.startTime)
            obj.endTime = Date.parse(obj.endTime)
        }
        if (startTime && !endTime) {
          obj.endTime = Date.now()
          obj.startTime = Date.parse(obj.startTime)
        }
        let res = await log.list(obj);

        this.total = res.data.pageinfo.totalCount
        this.list = res.data.data ;
        this.loading = false;
      },
    },
    mounted() {
      this.fetch();
    }
  };
</script>

<style>
  .user-list {
  }
</style>



// WEBPACK FOOTER //
// src/views/log/log-list.vue